import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { KnowledgeSuggestionEvidenceDialog } from "modules/knowledge/components/KnowledgeSuggestionEvidenceDialog"
import { Route as SuggestionsRoute } from "routes/_base/_auth/knowledge/suggestions"

export const Route = createFileRoute("/_base/_auth/knowledge/suggestions/$gapId/evidence")({
  component: RouteComponent,
})

function RouteComponent() {
  const { gapId } = Route.useParams()
  const search = SuggestionsRoute.useSearch()
  const navigate = useNavigate()

  function onClose() {
    navigate({ to: "/knowledge/suggestions", search })
  }

  return <KnowledgeSuggestionEvidenceDialog gapId={gapId} onClose={onClose} />
}
